import { TagCategory } from '~/shared/types/tag-category';
import { getLcn } from '~/utils/labeled-classnames';
import TagPill from '../../tags/TagPill';
import { TagsInCategory } from './ChartsList';

export default function ChartsTagsInCategory({
  tagsInActiveCategory,
  activeTagCategory,
  setActiveTagFilter,
}: {
  tagsInActiveCategory: TagsInCategory
  activeTagCategory: TagCategory
  setActiveTagFilter: (filter: string) => void
}) {
  const lcn = getLcn({
    chartsTagsInCategory: 'bg-gray-500 p-3 flex flex-wrap gap-2 ',
  });

  const sortedLabels = Object.keys(tagsInActiveCategory).sort()

  return (
    <div className={lcn.chartsTagsInCategory}>
      {sortedLabels.map(label => {
        const tagInCategory = tagsInActiveCategory[label];
        return (
          <TagPill
            key={tagInCategory.tagId}
            tag={tagInCategory.tag}
            count={tagInCategory.count}
            onClick={() => setActiveTagFilter(label)}
          />
        )
      })}

    </div>
  );
}; 